import { render, staticRenderFns } from "./SyntheseList.vue?vue&type=template&id=97ec18ae&scoped=true&"
import script from "./SyntheseList.vue?vue&type=script&lang=js&"
export * from "./SyntheseList.vue?vue&type=script&lang=js&"
import style0 from "./SyntheseList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SyntheseList.vue?vue&type=style&index=1&id=97ec18ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ec18ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97ec18ae')) {
      api.createRecord('97ec18ae', component.options)
    } else {
      api.reload('97ec18ae', component.options)
    }
    module.hot.accept("./SyntheseList.vue?vue&type=template&id=97ec18ae&scoped=true&", function () {
      api.rerender('97ec18ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SyntheseList.vue"
export default component.exports